<script setup lang="ts">
import { computed, reactive, ref, toRaw } from 'vue';

import KBtn from '@/components/btns/KBtn.vue';
import DetailedJobAttachmentsValidatedDropZoneField from '@/components/fields/DetailedJobAttachmentsValidatedDropZoneField.vue';
import useForm from '@/composables/useForm';

export interface InitialData {
  attachments?: File[];
}

export interface ValidData {
  attachments: File[];
}

export interface Props {
  loading?: boolean;
  initialData?: InitialData;
  dropZoneVariant?: 'button' | 'dropzone';
}
const props = withDefaults(defineProps<Props>(), {
  loading: false,
  initialData: () => ({}),
  dropZoneVariant: 'button',
});
const emit = defineEmits<{
  submit: [formData: ValidData, cb: () => void];
}>();

const formData = reactive<InitialData>({});
const isValid = ref(true);

const { form, handleSubmit } = useForm(props, formData, () => {
  emit('submit', toRaw(formData) as ValidData, () => {
    formData.attachments = []; // TODO HACK form reset with attachments
  });
});

const attachmentsLimit = 0;

const isAttachmentsLimit = computed(() => {
  return (
    // TODO
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    attachmentsLimit && (formData.attachments?.length || 0) > attachmentsLimit
  );
});
</script>

<template>
  <v-form
    ref="form"
    v-model="isValid"
    validate-on="lazy"
    :class="$style.detailedJobAttachmentsForm"
    data-testid="detailedJobAttachmentsForm"
    @submit.prevent="handleSubmit"
  >
    <DetailedJobAttachmentsValidatedDropZoneField
      v-model="formData.attachments"
      :limit="attachmentsLimit"
      :disabled="props.loading"
      :variant="props.dropZoneVariant"
      :class="$style.field"
    />
    <KBtn
      v-if="!!formData.attachments?.length"
      type="submit"
      size="md"
      append-icon="mdi-download-outline"
      :loading="props.loading"
      :disabled="
        !isValid || isAttachmentsLimit || !formData.attachments?.length
      "
      :class="$style.submit"
    >
      Upload
    </KBtn>
  </v-form>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.field {
  margin-bottom: 0.5rem;
}
</style>
